/* This initializer will detect if the page is embedded in an iframe and
 * load the iframe-resizer library if it is. The iframe-resizer allows us
 * to resize the parent iframe to the size of the embedded page.
*/

const detectAndLoadIframeResizer = async () => {
  const isIframe = typeof window !== 'undefined' && window.self !== window.top;
  if (!isIframe || window.iFrameResize) {
    return
  }

  await import("iframe-resizer")
}

detectAndLoadIframeResizer()
